export default __webpack_public_path__ + "static/media/icon2.b4fa9cea.png";